// 斑斑驾道学员端接口
import axios from '@/utils/axios'
const api = {
  businessCard: {},
  turntableActivity: {}
};

/**
 * @name 查询活动详情
 */
api.turntableActivity.getDetail = res => axios({
  method: 'GET',
  url: '/bbxc/order/inner/turntable/get',
  params: res
});

/**
 * @name 分页查询约车记录
 */
api.turntableActivity.getUserAppointmentCarRecord = res => axios({
  method: 'POST',
  url: '/zjerp/outer/appointmentCarRecord/v1/getUserAppointmentCarRecord',
  data: res
});

/**
 * @name 生成场景码
 */
api.businessCard.dynamicsScene = res => axios({
  method: 'POST',
  url: '/bbxc/operate/outer/operateScene/v1/dynamicsScene',
  data: res
});

/**
 * @name 生成两员名片小程序码
 */
api.businessCard.getUnlimitedQRCode = res => axios({
  method: 'POST',
  url: '/user/outer/cardUser/v1/getUnlimitedQRCode',
  data: res
});

/**
 * @name 生成驾校小程序码
 */
api.businessCard.getCoachMemberQrcode = res => axios({
  method: 'GET',
  url: '/bbxc/tenant/outer/channelMember/v1/getCoachMemberQrcode',
  params: res
});

/**
 * @name 查询默认展示小程序码类型
 */
api.businessCard.getDefaultCodeType = res => axios({
  method: 'GET',
  url: '/bbxc/operate/inner/operateShareConfig/v1/defaultList',
  params: res
});

/**
 * @name 生成个人名片小程序码
 */
api.businessCard.getAppCode = res => axios({
  method: 'POST',
  url: '/bbxc/operate/outer/coachZsClass/getAppCode',
  data: res
});

/**
 * @name 获取小程序原始ID
 */
api.businessCard.getShareCardData = res => axios({
  method: 'GET',
  url: '/user/outer/cardUser/v1/getShareCardData',
  params: res
});

/**
 * @name 通过教练ID查询教练信息
 */
api.businessCard.getCardUserByUserId = res => axios({
  method: 'GET',
  url: '/user/outer/cardUser/v1/getCardUserByUserId',
  params: res
});

/**
 * @name 荣誉证书埋点保存分享时候触发
 */
api.businessCard.buryingPoint = data => axios({
  method: 'POST',
  url: '/bbxc/operate/outer/certificate/v1/saveUseDetail',
  data
})

export default api;
